'use strict';

function isMobile() {
  return window.innerWidth < 769;
}

function isTablet() {
  return window.innerWidth >= 769 && window.innerWidth <= 1024;
}

function checkScreenSize() {
  isMobile()
    ? document.body.classList.add('is-mobile')
    : document.body.classList.remove('is-mobile');
  isTablet()
    ? document.body.classList.add('is-tablet')
    : document.body.classList.remove('is-tablet');
}

function init() {
  window.addEventListener('resize', () => {
    checkScreenSize();
  });

  checkScreenSize();
}

module.exports = {
  isMobile,
  isTablet,
  init
};



// WEBPACK FOOTER //
// ./src/js/screen.js